// The .mc scope for B6 pieces mounted from a V1 screen (an AckPair on a V1 packets row, the revoked packet on the V1
// packet route). The V1 content slot is not a .mc scope, so the piece carries it: inside a McRoot (the shell's) it is a
// plain .mc box sharing the root's instant and flags; on its own it is its own McRoot. Nothing V1 renders inside it.
// The same rule as B1's McPage, which is not on this trunk yet; when it lands this can import that instead.

import type { ReactNode } from "react";
import { McRoot, useMc } from "@/mc";

export function McScope({ children, inline }: { children: ReactNode; inline?: boolean | undefined }) {
  // Outside any McRoot the context answers instant 0 with every flag off; a mounted root has a real instant.
  const inRoot = useMc().now !== 0;
  if (inRoot) return inline ? <span className="mc">{children}</span> : <div className="mc">{children}</div>;
  return <McRoot>{children}</McRoot>;
}
